<ng-container *ngIf="isLoading;else pageContent">
	<div class="app-spinner">
		<mat-spinner diameter="60"></mat-spinner>
	</div>
</ng-container>

<ng-template #pageContent>
<div class="quiz-page">

  <h1 class="title">Published Quizzes</h1>
  <p class="subtitle">View and manage quizzes across all classrooms</p>

  <div class="tabs-container mb-4">
    <button 
      class="tab"
      [class.active]="selectedTab === QuizTabStatus.ALL"
      (click)="selectTab(QuizTabStatus.ALL)">
      All
    </button>

    <button 
      class="tab"
      [class.active]="selectedTab === QuizTabStatus.PENDING"
      (click)="selectTab(QuizTabStatus.PENDING)">
      Pending Quizzes
    </button>

	<button 
      class="tab"
      [class.active]="selectedTab === QuizTabStatus.IN_PROGRESS"
      (click)="selectTab(QuizTabStatus.IN_PROGRESS)">
      In Progress Quizzes
    </button>

    <button 
      class="tab"
      [class.active]="selectedTab === QuizTabStatus.COMPLETE"
      (click)="selectTab(QuizTabStatus.COMPLETE)">
      Completed Quizzes
    </button>
  </div>

  <div class="tab-content">

    <div class="top-bar">

      <input type="text"
        class="search-input"
        placeholder="Search by Quiz Name"
        [(ngModel)]="searchCourseByName"
        (ngModelChange)="onSearchChange($event)" />

      <ng-container>
        <ng-container *ngIf="!classroomFilter || classroomFilter == 0; else chipClassroom">
          <div class="select-wrapper">

            <select class="filter-select"
              [(ngModel)]="classroomFilter"
              (change)="onFilterChange()">
              <option [value]="0">All Classrooms</option>
              <option *ngFor="let classroom of classrooms" [value]="classroom.id"> {{ classroom.name }}
              </option>
            </select>

            <i class="bi bi-chevron-down select-arrow"></i>
          </div>
        </ng-container>

        <ng-template #chipClassroom>
          <div class="filter-chip">
            Classroom: <span>{{ getSelectedClassroomName() }}</span>
            <span class="close-icon" (click)="clearClassroom()">✕</span>
          </div>
        </ng-template>
      </ng-container>

    </div>

    <div class="table-card">
      <table class="quiz-table">
        <thead>
          <tr>
            <th>S.NO</th>
            <th>Quiz Name</th>
            <th>Classroom</th>
            <th>Create Date</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          <ng-container *ngIf="studentQuizzes.length > 0; else noData">
            <tr *ngFor="let studentQuiz of studentQuizzes; let i = index">
              <td>{{ (pageNo - 1) * pageSize + i + 1 }}</td>
              <td class="quiz-name">{{ studentQuiz.quiz_name }}</td>
              <td>{{ studentQuiz.classroom }}</td>
              <td>{{ studentQuiz.published_date | date:'MMM d, y' }}</td>
              <td>
                <span class="status-badge"
                  [ngClass]="{
                    'pending': studentQuiz.status === QuizTabStatus.PENDING,
                    'published': studentQuiz.status === QuizTabStatus.COMPLETE,
                    'in-progress': studentQuiz.status === QuizTabStatus.IN_PROGRESS,
                    'all': studentQuiz.status === QuizTabStatus.ALL,
                }">
                  {{ studentQuiz.status }}
                </span>
              </td>
              <td>
                <button class="btn-add" (click)="goToQuizPage(studentQuiz)">View</button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>

      <ng-template #noData>
        <tr>
          <td colspan="6">
            <div class="empty-row">No quizzes available</div>
          </td>
        </tr>
      </ng-template>

      <p-paginator
        [rows]="pageSize"
        [totalRecords]="totalCount"
        [rowsPerPageOptions]="[5, 10, 20, 30, 40, 50, 100]"
        (onPageChange)="onPageChange($event)">
      </p-paginator>
    </div>

  </div>

</div>
</ng-template>